import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { useLanguage } from '../../context/LanguageContext';
import { useProjectAnalysis } from './useProjectAnalysis';
import TriNodeHero from '../../components/project/TriNodeHero';
import KpiStrip from '../../components/project/KpiStrip';
import ProvenanceStrip from '../../components/project/ProvenanceStrip';

/**
 * Equilibrium (Part 3-4): the domain hero.
 *
 * The tri-node balance (effRRC / RAC / effPTBC -> CC = min) with each node
 * citing its origin and its glass box, the equilibrium KPI strip, and the
 * provenance strip that makes visible what was computed vs defaulted. This is
 * the screen the North Star was built around.
 */
const EquilibriumPage: React.FC = () => {
  const { block2, block3, block4, block7, part3, part4, part5, apcas, provenance } = useProjectAnalysis();
  const { theme } = useTheme();
  const { language } = useLanguage();
  const isDark = theme === 'dark';
  const lang = language === 'es' ? 'es' : 'en';

  return (
    <div className="space-y-6 animate-fade-in">
      <TriNodeHero
        block7={block7}
        block4={block4}
        block2={block2}
        block3={block3}
        part3={part3}
        isDark={isDark}
        language={lang}
      />
      <KpiStrip
        part3={part3}
        part4={part4}
        part5={part5}
        apcas={apcas}
        isDark={isDark}
        language={lang}
      />
      <ProvenanceStrip provenance={provenance} isDark={isDark} language={lang} />
    </div>
  );
};

export default EquilibriumPage;
